import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './aws-exports';
import store from './redux/store';

import 'ag-grid-community/dist/styles/ag-grid.css';
import './css/ag-grid-theme.css';
import 'semantic-ui-css/semantic.min.css';
import './css/index.css';

Amplify.configure(config);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
